import { render } from "./Itineraries.vue?vue&type=template&id=a8eb544e&scoped=true"
import script from "./Itineraries.vue?vue&type=script&lang=js"
export * from "./Itineraries.vue?vue&type=script&lang=js"

import "./Itineraries.vue?vue&type=style&index=0&id=a8eb544e&scoped=true&lang=css"
import "./Itineraries.vue?vue&type=style&index=1&id=a8eb544e&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8eb544e"],['__file',"src/views/Itineraries/Itineraries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8eb544e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8eb544e', __exports__)) {
    console.log('reload')
    api.reload('a8eb544e', __exports__)
  }
  
  module.hot.accept("./Itineraries.vue?vue&type=template&id=a8eb544e&scoped=true", () => {
    console.log('re-render')
    api.rerender('a8eb544e', render)
  })

}


export default __exports__